// @ts-nocheck
/* eslint-disable */
export const appChart64Icon = {
    data: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="32" fill="currentColor" fill-opacity="0.3"/><rect x="38" y="30" width="6" height="14" rx="2" fill="currentColor"/><rect x="29" y="20" width="6" height="24" rx="2" fill="currentColor"/><rect x="20" y="34" width="6" height="10" rx="2" fill="currentColor"/></svg>`,
    name: 'chart-64' as const
};